import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { Months } from '../../data/months';
import { Month } from '../../models/month';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { sortBy } from 'sort-by-typescript';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { LabelComponent } from '@progress/kendo-angular-label';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';

@Component({
    selector: 'app-date-filter',
    templateUrl: './date-filter.component.html',
    styleUrl: './date-filter.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        LabelComponent,
        MultiSelectComponent,
    ],
})
export class DateFilterComponent {
    private mixpanelService = inject(MixpanelService);

    readonly formGroup = input.required<FormGroup>();
    readonly yearsFormControlName = input.required<string>();
    readonly monthsFormControlName = input.required<string>();
    readonly startYear = input<number>(2021);

    years: number[] = [];
    months: Month[] = Months;

    constructor() {
        this.buildYearList();
    }

    buildYearList() {
        this.years = [];

        let currentYear = new Date().getFullYear();
        let yearToAdd = this.startYear();

        while (yearToAdd <= currentYear) {
            this.years.push(yearToAdd);
            yearToAdd += 1;
        }

        this.years = this.years.sort(sortBy('-'));
    }
    onMonthSelectionChange() {
        this.mixpanelServicetrack();
    }

    onYearSelectionChange() {
        this.mixpanelServicetrack();
    }

    mixpanelServicetrack() {
        var menuName = 'Date Range Change';
        const userEmail = localStorage.getItem('userEmail') || '';
        const eventName = `${menuName.toLowerCase().replace(/ /g, '_')}`;
        this.mixpanelService.track({
            id: userEmail,
            eventName: eventName,
            eventDisplayName: menuName,
            kpi: 'Changes in date range selector',
            trigger: 'When user selects a new date range',
            eventDefinition: 'Tracks user interaction with date selection',
            propertyDefinition: 'User-defined date range for the report',
            propertyType: 'selected_date_range',
        });
    }

    ngOnDestroy(): void {}
}
